<template>
    <div class="cblock display--flex">
        <operate
            v-if="showOperate"
            @close="showOperate = false, actions( 'controlActionBar', { type: 'hide', value: false })"
            :contact="{
                type: 'manual',
                id: contactId,
                workflow: 'leave',
                value: contactValue
            }"
        />
        <template >
                <div v-for=" ( email, index ) in emailContacts" :key="`email-${index}`"
                    class="cblock__contact position--relative svg--parent"
                    @mouseover="elements[`email${index}`].show = true"
                    @mouseleave="elements[`email${index}`].show = false">
                    <a :href="`mailto:${email['email']}`">
                            <icon-email class="cblock__icon svg svg--green pointer"/>
                    </a>
                    <input :ref="`email${index}`" type="hidden" :value="email['email']">
                    <tooltip
                        v-show="elements[`email${index}`].show"
                        class="cblock__tooltip--contact pointer"
                        direction="top"
                        animation="top--base"
                        arrow="base"
                        v-html="email['email']"
                        @click.native="copy( `email${index}` )"
                    />
                    <tooltip
                        v-show="elements[`email${index}`].coppied"
                        class="cblock__tooltip--info"
                        direction="right"
                        v-html="$t('global.coppied')"
                    />
                </div>
                <div
                    class="cblock__contact position--relative svg--parent"
                    v-for=" ( phone, index ) in phoneContacts" :key="`phone-${index}`"
                    @mouseover="elements[`phone${index}`].show = true"
                    @mouseleave="elements[`phone${index}`].show = false">
                    <button
                        class="cblock__button"
                        @click="openModal = true; contactValue = phone['phone'] "
                        :disabled=" !getters.can( 'audit', 'manualContact' ) "
                    >
                        <icon-phone class="cblock__icon svg svg--green pointer"/>
                    </button>
                    <input :ref="`phone${index}`" type="hidden" :value="phone['phone']">
                    <tooltip
                        v-show="elements[`phone${index}`].show"
                        class="cblock__tooltip--contact pointer"
                        direction="top"
                        animation="top--base"
                        arrow="base"
                        v-html="phone['phone']"
                        @click.native="copy( `phone${index}` )"
                    />
                    <tooltip
                        v-show="elements[`phone${index}`].coppied"
                        class="cblock__tooltip--info"
                        direction="right"
                        v-html="$t('global.coppied')"
                    />
                    <modal
                        v-if="openModal"
                        :form="{
                            class: 'cblock__modal'
                        }"
                        :customSettings="{
                            class: 'cblock__modal__content',
                            position: 'center',
                            color: 'green',
                            button: {
                                label: 'confirm',
                                type: 'button',
                                action: () => {
                                    showOperate = true,
                                    openModal = false,
                                    contactId = data.id,
                                    contactValue = contactValue,
                                    actions( 'controlActionBar', { type: 'hide', value: true })
                                }
                            }
                        }"
                        @close="openModal = false"
                        :key="openModal"
                    >
                        <template #modal__header >
                            <h2 class="cblock__modal__header">{{ $t('global.manualCall') }}</h2>
                        </template>
                        <template #modal__body__confirm >
                            <span class="cblock__modal__info display--block capitalize">
                                {{ $t('global.areYouSureYouWantToCall') + getCallInfo( data ) + ' - ' + contactValue + ' ?'}}
                            </span>
                        </template>
                        <template #modal__info >
                            <base-button
                                class="modal__content__button--negative background--transparent border--grey"
                                @click="openModal = false; contactValue = null"
                                v-html="$t('global.cancel')"
                            />
                        </template>
                    </modal>
                </div>
        </template>
    </div>
</template>

<script>
// vue
import Vue from 'vue';

// packages
import { reactive, toRefs, ref } from '@vue/composition-api';

// utils
import { firstLastWords } from '@/utils/';

// store
import { useStore } from '@/hooks/use-store';

export default {
    components: {
        IconEmail: () => import( /* webpackChunkName: 'IconEmail' */ '@/components/bundles/layout/images/icons/IconEmail' ),
        IconPhone: () => import( /* webpackChunkName: 'IconPhone' */ '@/components/bundles/layout/images/icons/IconPhone' ),
        Tooltip: () => import( /* webpackChunkName: 'Tooltips' */ '@/components/bundles/tooltips/Tooltip' ),
        Operate: () => import( /* webpackChunkName: 'Operate' */ '@/components/bundles/operate/Operate' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' )
    },
    props: {
        value: Array,
        data: Object
    },
    setup ( props ) {
        const { getters, actions } = useStore();
        // construção de um objecto com os contactos
        // de forma a ser mais fácil trabalhar no HTML.
        const contactsObject = reactive({});
        const showOperate = ref( false );
        const phoneContacts = [];
        const emailContacts = [];
        const mobileContacts = [];

        props.value.forEach( element => {
            if ( typeof element.phone !== 'undefined' && element.primary )
                phoneContacts.push( element );
            if ( typeof element.email !== 'undefined' && element.primary )
                emailContacts.push( element );
            if ( typeof element.mobile !== 'undefined' && element.primary )
                mobileContacts.push( element );
        });

        // obter informação de contacto para apresentar na modal
        const getCallInfo = info => {
            const fullName = firstLastWords( info.person.name );

            return fullName;
        };

        const contacts = [
            { anchor: 'mailto:', key: 'email' },
            { anchor: 'tel:', key: 'mobile' },
            { anchor: 'tel:', key: 'phone' }
        ];

        const elements = reactive({});
        const inputs = reactive({});

        // preencher objeto elements e inputs - PHONE
        if ( phoneContacts.length ) {
            phoneContacts.forEach( ( phone, index ) => {
                Vue.set( elements, `phone${index}`, { show: false, coppied: false, primary: phone.primary });
                inputs[`phone${index}`] = null;
            });
        }

        // preencher objeto elements e inputs - EMAIL
        if ( emailContacts.length ) {
            emailContacts.forEach( ( email, index ) => {
                Vue.set( elements, `email${index}`, { show: false, coppied: false, primary: email.primary });
                inputs[`email${index}`] = null;
            });
        }

        // preencher objeto elements e inputs - MOBILE
        if ( mobileContacts.length ) {
            mobileContacts.forEach( ( mobile, index ) => {
                Vue.set( elements, `mobile${index}`, { show: false, coppied: false, primary: mobile.primary });
                inputs[`mobile${index}`] = null;
            });
        }

        // função para copiar o valor do contacto
        // para o clipboard ( ctrl+c ).
        const copy = key => {
            // é necessário o [0], porque quando
            // declarado um `ref` dentro de um for, o valor
            // que é retornado é sempre um array.
            inputs[key][0].type = 'text';
            inputs[key][0].select();
            document.execCommand( 'copy' );
            inputs[key][0].type = 'hidden';

            // apresentação que o contacto foi copiado.
            // coppied[key] = true;
            elements[key].coppied = true;

            // removido a apresentação.
            setTimeout( () => {
                elements[key].coppied = false;
            }, 600 );
        };
        const bools = reactive({
            openModal: false
        });

        const contactInfo = reactive({
            contactId: null,
            contactValue: null
        });

        const contactType = 'manual';
        return {
            ...toRefs( inputs ),
            ...toRefs( bools ),
            ...toRefs( contactInfo ),
            contactsObject,
            elements,
            contacts,
            copy,
            getCallInfo,
            showOperate,
            contactType,
            getters,
            actions,
            phoneContacts,
            emailContacts
        };
    }
};
</script>

<style lang="scss">
    .cblock {
        flex-wrap: wrap;
        &__contact {
            padding-top: 10px;
            margin-top: -10px;
            &:not(:last-child) {
                margin-right: 10px;
            }
        }
        &__tooltip {
            &--contact {
                white-space: nowrap;
                @include transform-position( -20px, false, false, 0 );
            }
            &--info {
                @include transform-position( 11px, false, false, 130% );
            }
        }
        &__button{
            background: unset;
        }
        &__modal {
            &__header {
                @include typography-specs( 25px, 33px, 700 );
            }
            &__content {
                max-width: 480px;
            }
        }
    }
</style>